import React from "react"
import styled from "@emotion/styled"
import Box, { BoxProps } from "@/components/Box"
import { variant } from "styled-system"

const Input = styled(Box)`
  appearance: none;
  border: none;
  background-color: transparent;
  -moz-appearance: none;
  -webkit-appearance: none;
  ${variant({
    variants: {
      default: {
        fontFamily: "heading",
        fontSize: 16,
        lineHeight: "135%",
        letterSpacing: "0.015em",
        fontWeight: "600",
        height: 52,
        border: "2px solid #9EA1A2",
        borderRadius: 8,
        paddingLeft: 2,
        ":focus": {
          outline: "none",
        },
        "::placeholder": {
          color: "#9EA1A2",
          fontFamily: "heading",
          fontSize: 16,
          lineHeight: "135%",
          letterSpacing: "0.015em",
          fontWeight: "600",
        },
      },
      desktop: {
        fontFamily: "heading",
        fontSize: [20, 20, 21.5],
        lineHeight: ["145%", "145%", "100%"],
        letterSpacing: ["0.02em", "0.015em", "0.02em"],
        fontWeight: ["600", "600", "600"],
        ":focus": {
          border: "none",
          outline: "none",
        },
        "::placeholder": {
          color: "#9EA1A2",
          fontFamily: "heading",
          fontSize: 16,
          lineHeight: "135%",
          letterSpacing: "0.015em",
          fontWeight: "600",
        },
      },
    },
  })}
`
type InputProps = BoxProps & {
  variant?: "default"
  type?: string
  value: string
  onChange: (value: string) => void
  ariaLabel?: string
}

export const SearchBar = ({
  variant = "default",
  type = "text",
  value,
  onChange,
  ariaLabel,
  ...props
}: InputProps) => {
  const inputId = `serach-input-${ariaLabel}`
  return (
    <>
      <label htmlFor={inputId} style={{ display: "none" }}>
        Search
      </label>
      <Input
        variant={variant}
        type={type}
        id={inputId}
        value={value}
        {...props}
        as="input"
        placeholder="Search by role or keyword"
        onChange={event =>
          onChange((event.target as HTMLTextAreaElement).value)
        }
        aria-label={ariaLabel}
      />
    </>
  )
}
